export const dataTeam = [
    {
        id: 1,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        email: "example@gmail.com",
        // adresse: "AZ 60 K III",
        sexe: "homme",
        niveau: "Mairie"
    },
    {
        id: 2,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        niveau: "Adjoint"
    },
    {
        id: 3,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        email: "example@gmail.com",
        // adresse: "AZ 60 K III",
        sexe: "homme",
        niveau: "Secretaire"
    },
    {
        id: 4,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        email: "example@gmail.com",
        // adresse: "AZ 60 K III",
        sexe: "homme",
        niveau: "User"
    },
]